module.exports = __webpack_public_path__ + "static/media/celeiro.c2598c51.png";